import axios from "../../axios";

const api = {
  getConsumptionBasedDirectEmissionsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/consumption-based/${params.questionnaireId}/direct-emissions/${params.type}`,
      config).then(({ data }) => data);
  },

  addConsumptionBasedDirectEmissionsItem({ questionnaireId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/consumption-based/${questionnaireId}/direct-emissions/${type}`, data, headers)
      .then(({ data }) => data);
  },

  updateConsumptionBasedDirectEmissionsItem({ questionnaireId, recordId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/consumption-based/${questionnaireId}/direct-emissions/${type}/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteConsumptionBasedDirectEmissionsItem({ questionnaireId, recordId, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/supplier-questionnaires/consumption-based/${questionnaireId}/direct-emissions/${type}/${recordId}`, headers)
      .then(({ data }) => data);
  }
};

export default api;